import { createApp, h } from 'vue'
import PollCreatePage from './Pages/Public/PollCreatePage.vue'

const root = document.getElementById('public-poll-create-root')

if (root) {
    const payload = root.getAttribute('data-props')
    const props = payload ? JSON.parse(payload) : {}
    createApp({
        render: () => h(PollCreatePage, props),
    }).mount(root)
}
